<ng-container *ngIf="isLocationSetTypeParent">
    <mat-form-field class="menu-filter">
        <mat-label>Select Location Set Type Parent</mat-label>
        <input
            aria-label="Location Set Type Parent"
            [attr.data-testid]="'location_set_type_select'"
            [formControl]="locationSetCtrl"
            [matAutocomplete]="parentAuto"
            matInput
            [placeholder]="placeholderTextParent"
        />
        <mat-autocomplete
            #parentAuto="matAutocomplete"
            [displayWith]="autoCompleteDisplay"
            class="offset"
        >
            <mat-option
                *ngFor="let parentLocationSet of parentLocationSets"
                [attr.data-testid]="parentLocationSet.name + '_option'"
                [value]="parentLocationSet"
            >
                {{ parentLocationSet.name }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
</ng-container>
<mat-form-field *ngIf="locationSets && !isLocationSetTypeParent" class="menu-filter">
    <mat-label>Select Location Set</mat-label>
    <input
        aria-label="Location Set"
        [attr.data-testid]="placeholderText + '_select'"
        [formControl]="locationSetCtrl"
        [matAutocomplete]="auto"
        matInput
        [placeholder]="placeholderText"
    />
    <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="autoCompleteDisplay"
        class="offset"
    >
        <mat-option
            *ngFor="let locationSet of locationSets"
            [attr.data-testid]="locationSet.name + '_option'"
            [value]="locationSet"
        >
            <span>{{ locationSet.tag }} - {{ locationSet.name }}</span>
        </mat-option>
    </mat-autocomplete>
    <button
        *ngIf="locationSetCtrl.value"
        [attr.data-testid]="'location_set_close_button'"
        matSuffix mat-icon-button aria-label="Clear"
        (click)="resetSelectedLocationSet()"
    >
        <mat-icon>close</mat-icon>
    </button>
</mat-form-field>
<mat-form-field *ngIf="!hideVenueSelector && !(selectedLocationSetType.tag !== 'LOCATION') && selectedFeatureScope === 'Viewer'"
                class="menu-filter">
    <mat-label>Select Venue (Optional)</mat-label>
    <input
        aria-label="Venue"
        [attr.data-testid]="venuePlaceHolderText + '_select'"
        [formControl]="venueCtrl"
        [matAutocomplete]="venueAuto"
        matInput
        [placeholder]="venuePlaceHolderText"
    />
    <mat-autocomplete
        #venueAuto="matAutocomplete"
        [displayWith]="autoCompleteDisplayVenue"
        class="offset"
    >
        <mat-option
            *ngFor="let venue of venues;"
            [attr.data-testid]="venue.venueId+ '_option'"
            [value]="venue"
        >
            <span *ngIf="venue.name">{{ venue.name }}</span>
            <span *ngIf="!venue.name">{{ venue.venueId }}</span>
        </mat-option>
    </mat-autocomplete>
    <button
        *ngIf="venueCtrl.value"
        [attr.data-testid]="'venue_close_button'"
        matSuffix mat-icon-button aria-label="Clear"
        (click)="resetSelectedVenueId()"
    >
        <mat-icon>close</mat-icon>
    </button>
</mat-form-field>
